import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { ArrowUpDown, AlertTriangle, Tag, TrendingDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const insights = [
  { icon: ArrowUpDown, title: "Übergaberate", value: "15%", desc: "der Chats werden an Live-Agenten übergeben", color: "text-chathero-orange" },
  { icon: AlertTriangle, title: "Eskalationen", value: "88", desc: "Anzahl Eskalationen im Zeitraum", color: "text-primary" },
  { icon: Tag, title: "Themen-Cluster", value: "Top 7", desc: "Anfragekategorien mit hohem Supportbedarf", color: "text-chathero-mint" },
];

const outcomes = [
  "Wo Automatisierung erweitert werden kann",
  "Welche Anfragen Prozesse verlangsamen",
  "Wie sich Servicekosten reduzieren lassen",
];

const AnalyticsProzesseSection = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className={cn(
        "py-16 md:py-24 transition-all duration-700 ease-out",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      )}
    >
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">Prozesse</Badge>
            <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
              Prozesse analysieren & Effizienz steigern
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Erkennen Sie, wo operative Ressourcen gebunden werden – und wo Automatisierung weiter greifen kann.
            </p>

            <div className="space-y-4 mb-8">
              {insights.map((item, i) => (
                <div key={i} className="flex gap-4 p-4 bg-card border border-border rounded-xl shadow-sm">
                  <div className={cn("w-10 h-10 rounded-xl bg-secondary flex items-center justify-center shrink-0", item.color)}>
                    <item.icon className="w-5 h-5" />
                  </div>
                  <div>
                    <div className="flex items-baseline gap-2 mb-1">
                      <span className={cn("text-2xl font-bold", item.color)}>{item.value}</span>
                      <span className="font-semibold text-foreground text-sm">{item.title}</span>
                    </div>
                    <p className="text-xs text-muted-foreground">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-secondary/40 to-card border border-border rounded-2xl p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <TrendingDown className="w-6 h-6 text-chathero-mint" />
              <h3 className="text-lg font-bold text-foreground">Sie erkennen konkret:</h3>
            </div>
            <div className="space-y-4">
              {outcomes.map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-chathero-mint/20 flex items-center justify-center shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-chathero-mint">{i + 1}</span>
                  </div>
                  <p className="text-muted-foreground">{item}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 pt-6 border-t border-border">
              <p className="text-sm text-center font-semibold text-chathero-mint">
                Ergebnis: höhere Effizienz bei gleichbleibender Servicequalität.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnalyticsProzesseSection;
